import oidcConfig from "../utils/oidcConfig";
import http from "./http.api";

export const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  const logouturl = `${oidcConfig.authority}/oauth2/logout/?client_id=${oidcConfig.client_id}&redirect_uri=${oidcConfig.logout_redirect_uri}`;
  window.location.href = logouturl;
};

export const getCarLookup = async (projectId: string) => {
  try {
    const url = `/v1/Lookup/create-car?projectId=${projectId}`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error("Error creating car:", error);
    throw error;
  }
};

export const fetchSummaryReportData = async (selectedId: string) => {
  try {
    const url = `/v1/SummaryReport/summaryReport/${selectedId}`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching summary report:", error);
    throw error;
  }
};

export const getProductList = async (opId: string) => {
  try {
    const url = `v1/SummaryReport/summaryReport/opportunitycertificate?OpportunityId=${opId}&RecordType=Food%20and%20Agriculture`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error("Error creating car:", error);
    throw error;
  }
};


export const getCarmessages = async (carId: string) => {
  try {
    const url = `/v1/Messaging/car/${carId}/loggedinuser/messages`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error('Error creating car:', error);
    throw error;
  }
};


export const postCarmessages = async (requestData: object) => {
  try {
    const url = `/v1/Messaging`;
    const response = await http.post(url, requestData);
    return response.data;
  } catch (error) {
    console.error('Error creating car:', error);
    throw error;
  }
};
export const getCar = async (id: string) => {
  try {
    const url = `/v1/CorrectiveActionRequest/car/${id}`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching car:", error);
    throw error;
  }
};
